module.exports = __webpack_public_path__ + "static/media/day.c850e77f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/overlay-icons/day.svg
// module id = 842
// module chunks = 0